/**
 * Generates a random UUID v4 string
 * @returns A UUID string in the format: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
 */
export function generateUUID(): string {
  return crypto.randomUUID();
}

/**
 * Generates a random alphanumeric string
 * @param length - Length of the string (default: 10)
 * @returns A random alphanumeric string
 */
export function generateRandomString(length: number = 10): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const array = new Uint32Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, (n) => chars[n % chars.length]).join('');
}